import { useCustomTranslation } from '../../../../../hooks';
import { useMutation } from '@tanstack/react-query';
import { graphneAPI, SoftResourceAreaUnassignmentRequest } from '@nexelem/graphne-api';
import { useCustomToast } from '@nexelem/snackbar';
import { closeAutoUnassigmentModal } from './AutoUnassignmentModal';

type UnassignAllWorkersPayload = SoftResourceAreaUnassignmentRequest & {
  onlyUnavailable: boolean;
};

export const useUnassignAllWorkersMutation = () => {
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');
  return useMutation({
    mutationFn: ({ onlyUnavailable, ...payload }: UnassignAllWorkersPayload) => {
      if (onlyUnavailable) {
        return graphneAPI.postGraphneResourcesSoftUnassignUnavailable({
          softResourceAreaUnassignmentRequest: payload,
        });
      } else {
        return graphneAPI.postGraphneResourcesSoftUnassignAll({
          softResourceAreaUnassignmentRequest: payload,
        });
      }
    },
    onSuccess: () => {
      closeAutoUnassigmentModal();
      displayToast({
        toastType: 'success',
        message: tWrapper('unassignSuccess'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('unassignError'),
      });
    },
  });
};
